import React from "react";
import { withRedux } from "helpers";
import { SelectOptions } from "components";
import { FlexRow, P } from "appStyles";
import NotificationForm from "./NotificationForm";
import Notifications from "./Notifications";
import AddCircleIcon from "@material-ui/icons/AddCircle";

class NotificationCenter extends React.Component {
  state = {
    title: "",
    text: "",
    templateId: null,
    hideNew: true,
    newId: null,
  };

  update = (field) => (value) => {
    this.setState({
      [field]: value,
    });
  };

  renderTemplateDropDown = () => {
    const {
      activeApp: {
        view: { templates },
      },
    } = this.props;
    const { templateId } = this.state;

    const options = [
      {
        value: null,
        label: "None",
      },
    ];
    templates.forEach((template) =>
      options.push({
        value: template.id,
        label: template.pageName,
      })
    );

    return (
      <FlexRow width="44%" margin="1em 0 1em 0">
        <P>Open to page: </P>
        <SelectOptions
          width="10em"
          options={options}
          setValue={this.update("templateId")}
          value={templateId}
        />
      </FlexRow>
    );
  };

  renderNotifications = () => {
    const { templates } = this.state;
    if (!templates) return null;

    return (
      <div>
        {templates &&
          templates.map((template) => {
            return <div>Template</div>;
          })}
      </div>
    );
  };

  renderNewNotification = () => {
    const { hideNew } = this.state;

    return (
      <div
        style={{
          boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
        }}
      >
        <div
          onClick={() => {
            this.setState({ hideNew: !hideNew });
          }}
          style={{
            left: "318px",
            width: "100%",
            top: "287px  ",
            background: "#89D2D3",
            display: "flex",
            flexDirection: "row",
            color: "white",
            padding: "15px",
            cursor: "pointer",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3
            style={{
              margin: "10px",
            }}
          >
            Create New Notification
          </h3>
          <AddCircleIcon style={{ marginRight: "5px" }}></AddCircleIcon>
        </div>

        {!hideNew && (
          <NotificationForm
            hideForm={() => {
              this.setState({ hideNew: !hideNew });
            }}
            fetchNotifications={(id) => this.setState({ newId: id })}
          />
        )}
      </div>
    );
  };

  render() {
    const { newId } = this.state;

    return (
      <div
        style={{
          margin: "0px 40px",
        }}
      >
        {this.renderNewNotification()}
        <Notifications newId={newId} />
      </div>
    );
  }
}

export default withRedux(NotificationCenter);
